export default "__VITE_ASSET__BDMWfVxh__"